<template>
    <div v-if="hasDegradedMode" class="notification is-warning degraded-mode-banner">
        <article class="media">
            <div class="media-left">
                <span class="icon">
                    <fa icon="exclamation-triangle" size="lg" fixed-width></fa>
                </span>
            </div>
            <div class="media-content">
                <div class="content">
                    <p>
                        <strong>Degraded Mode</strong>
                        <br />
                        <small>
                            Some services could not be loaded. The application
                            is running with limited functionality.
                        </small>
                    </p>
                    <div v-if="showDetails" class="degraded-details">
                        <p class="is-size-7 has-text-grey">Failed services:</p>
                        <ul class="is-size-7">
                            <li v-for="error in loadingErrors" :key="error.service">
                                <strong>{{ error.service }}</strong>: {{ error.message }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="media-right">
                <button
                    class="button is-small is-warning is-light"
                    @click="showDetails = !showDetails"
                >
                    <span class="icon is-small">
                        <fa :icon="showDetails ? 'chevron-up' : 'chevron-down'"></fa>
                    </span>
                    <span>{{ showDetails ? 'Hide' : 'Details' }}</span>
                </button>
                <button
                    class="button is-small is-warning ml-2"
                    @click="retryLoading"
                    :class="{ 'is-loading': isRetrying }"
                >
                    <span class="icon is-small">
                        <fa icon="redo"></fa>
                    </span>
                    <span>Retry</span>
                </button>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    name: 'DegradedModeBanner',

    data() {
        return {
            showDetails: false,
            isRetrying: false,
        };
    },

    computed: {
        hasDegradedMode() {
            return this.$store.getters['businessUnit/hasDegradedMode'];
        },
        loadingErrors() {
            return this.$store.getters['businessUnit/loadingErrors'];
        },
        project() {
            return this.$store.getters['businessUnit/project'];
        },
    },

    methods: {
        async retryLoading() {
            if (!this.project || this.isRetrying) return;

            this.isRetrying = true;
            try {
                await this.$store.dispatch('businessUnit/switch_project', {
                    project_id: this.project.id,
                });
            } catch (e) {
                console.error('Retry failed:', e);
            } finally {
                this.isRetrying = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.degraded-mode-banner {
    margin-bottom: 0 !important;
    border-radius: 0;
    padding: 0.75rem 1rem;

    .media {
        align-items: center;
    }

    .degraded-details {
        margin-top: 0.5rem;
        padding: 0.5rem;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 4px;

        ul {
            margin-left: 1rem;
            margin-top: 0.25rem;
        }
    }
}
</style>
